import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/** Retired admin workspace surfaces → workspace Home (not /admin Home). */
export default function AdminWorkspaceRedirect({ children }) {
  const { user } = useAuth();
  const { clientSlug } = useParams();
  if (user?.role === "admin") {
    return <Navigate to={`/${clientSlug}`} replace />;
  }
  return children;
}
